/*
  «Позвонить» и «Отправить СМС» в шапке карточки счёта (06.10.2026).

  До этого дня позвонить одному должнику из кабинета было нечем: метод звонка
  существовал, а кнопки не было (строка 115 реестра). Кнопки видны тем, кто
  работает с реестром, и выключены в режиме только чтения - отказ при нажатии
  объяснял бы то, что видно заранее.
*/

import { useState } from 'react'

import CallDialog from './CallDialog.jsx'
import SmsDialog from './SmsDialog.jsx'

export default function AccountContactActions({ card, profile }) {
  const [open, setOpen] = useState(null)
  if (!profile.permissions.includes('view_registry')) return null

  const title = `счёт ${card.number}`
  const locked = Boolean(profile.is_readonly)
  return (
    <>
      <button type="button" className="button" disabled={locked} onClick={() => setOpen('call')}>
        Позвонить
      </button>
      <button
        type="button"
        className="button button--quiet"
        disabled={locked}
        onClick={() => setOpen('sms')}
      >
        Отправить СМС
      </button>
      {open === 'call' ? (
        <CallDialog accountId={card.account_id} title={title} onClose={() => setOpen(null)} />
      ) : null}
      {open === 'sms' ? (
        <SmsDialog accountId={card.account_id} title={title} onClose={() => setOpen(null)} />
      ) : null}
    </>
  )
}
